'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["overlayPosition", "closeOverlay", "domNode", "className"];
import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import cx from 'classnames';
import { OverlayPortalContainer } from "./Container.js";
/**
 * 1. Renders a React Portal into a different part of the DOM to avoid component hierarchy and potential overflow issues
 * 2. Receives positional values of the trigger from ref and applies positioning to the overlay
 * 3. Renders nothing if scroll event fires on window. Avoids potential bug of tooltip staying still while trigger moves.
 *
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/OverlayPortal)
 */
export var OverlayPortal = function OverlayPortal(_ref) {
  var _ref$overlayPosition = _ref.overlayPosition,
    overlayPosition = _ref$overlayPosition === void 0 ? {
      width: 0,
      height: 0,
      top: 0,
      left: 0
    } : _ref$overlayPosition,
    closeOverlay = _ref.closeOverlay,
    _ref$domNode = _ref.domNode,
    domNode = _ref$domNode === void 0 ? document.body : _ref$domNode,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  useEffect(function () {
    if (!closeOverlay) {
      return function () {};
    }
    window.addEventListener('scroll', closeOverlay, true);
    return function () {
      window.removeEventListener('scroll', closeOverlay, true);
    };
  }, [closeOverlay]);
  return /*#__PURE__*/createPortal(/*#__PURE__*/React.createElement(OverlayPortalContainer, Object.assign({
    className: cx('encore-layout-themes', className),
    $overlayPosition: overlayPosition
  }, props)), domNode);
};